module.exports = __webpack_public_path__ + "img/v_mgs.b99e5d97.png";